import { render, staticRenderFns } from "./PinsLoginForm.vue?vue&type=template&id=6c1a6971&scoped=true&"
import script from "./PinsLoginForm.vue?vue&type=script&lang=js&"
export * from "./PinsLoginForm.vue?vue&type=script&lang=js&"
import style0 from "./PinsLoginForm.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"
import style1 from "./PinsLoginForm.vue?vue&type=style&index=1&id=6c1a6971&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1a6971",
  null
  
)

export default component.exports